module.exports = __webpack_public_path__ + "static/media/intro_page_picture3.7dd2d647.jpeg";